const handleMutation = (mutationList, observer) => {
  const textMElements = document.querySelectorAll('.text-m');
  if (textMElements.length === 0) {
    return;
  }

  textMElements.forEach((element) => {
    const txt = element.innerHTML.replace('Reviews', '').replace('Review', '');
    element.innerHTML = txt;
  });

  observer.disconnect();
};

const observer = new MutationObserver(handleMutation);

const ProductOverview = () => {
  document.querySelectorAll('[data-pdp-yotpo]').forEach((el) => {
    observer.observe(el, {
      childList: true,
    });
  });
};

document.addEventListener('quickViewDidLoad', () => {
  ProductOverview();
});

export default ProductOverview;
